import { Profession, ProfessionPreference } from "../lib/professionTypes";
import Papa from 'papaparse';

export async function loadProfessions(): Promise<Profession[]> {
  try {
    const response = await fetch('/professions.csv');
    const csvText = await response.text();

    const { data } = Papa.parse<{ ID?: string; Alcsoport?: string; Főcsoport?: string }>(csvText, {
      header: true,
      skipEmptyLines: true,
      delimiter: ';' // Using semicolon as delimiter
    });

    const professionsByName: Record<string, Profession> = {};

    (data as { ID?: string; Alcsoport?: string; Főcsoport?: string }[]).forEach(row => {
      const profession: Profession = {
        id: row.ID || (row.Alcsoport || '').toLowerCase().replace(/\s+/g, '-'),
        name: row.Alcsoport || '',
        category: row.Főcsoport || 'general',
        subCategories: []
      };

      if (!professionsByName[profession.name]) {
        professionsByName[profession.name] = profession;
      }
    });

    return Object.values(professionsByName);
  } catch (error) {
    console.error('Error loading professions:', error);
    return [];
  }
}

export function calculateProfessionMatchScore(
  eventProfessions: string[],
  userPreferences: ProfessionPreference[]
): number {
  let score = 0;
  const weights = { high: 3, medium: 2, low: 1 };

  eventProfessions.forEach(eventProf => {
    const preference = userPreferences.find(p => p.professionId === eventProf);
    if (preference) {
      score += weights[preference.level as keyof typeof weights];
    }
  });

  return score;
}
